import React, { useEffect } from "react";
import { RiSortDesc } from "react-icons/ri";
import Navbar from "../components/navbar";
import { useState, useMemo } from "react";
import Drawer from "react-bottom-drawer";
import { TfiMobile } from "react-icons/tfi";
import { useNavigate } from "react-router";
import API from "../services/API";
import { Spinner } from "react-bootstrap";
import LoadingBar from "react-top-loading-bar";
import ContentLoader, { Facebook } from "react-content-loader";
import FloatingButton from "../components/FloatingButton";
import "../css/Customer.css";
import "../css/global.css";
import { changeLanguage } from "i18next";
import { useTranslation } from "react-i18next";
import translate from "translate";

translate.engine = "google";
translate.key = process.env.DEEPL_KEY;

export default function Customer() {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [isFilterLoaded, setIsFilterLoaded] = useState(false);

  const [dropDownAreaData, setDropDownAreaData] = useState([]);
  const [customerData, setcustomerData] = useState([]);
  const [filtercustomerData, setfiltercustomerData] = useState([]);
  const [customerName1, setCustomerName] = useState("");
  const { t } = useTranslation();
  const savedFilters =
    JSON.parse(localStorage.getItem("customerFilters")) || {};

  const [sortOptions, setSortOptions] = useState(
    savedFilters.sortOptions || "All",
  );
  const [sortBy, setSortBy] = useState(savedFilters.sortBy || "CustomerId");
  const [sortType, setSortType] = useState(savedFilters.sortType || "ASC");
  const [area, setArea] = useState(savedFilters.area || "All");
  const [search, setSearch] = useState(savedFilters.search || "");
  const [isLoading, setisLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [progress, setProgress] = useState(0);
  const [translatedArea, setTranslatedArea] = useState("");
  const [translatedSearch, setTranslatedSearch] = useState("");
  const [translatedFilter, setTranslatedFilter] = useState("");
  const user = JSON.parse(
    localStorage.getItem("user") || sessionStorage.getItem("user"),
  );

  const fetchCustomerData = () => {
    console.log("API CALLED 🚀");
    setisLoading(true);

    API.allCustomerData({ agentId: user.agentId })
      .then((response) => {
        setcustomerData(response.data.results);
        setIsDataLoaded(true);
        setisLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setisLoading(false);
      });
  };

  const localstorageValue = localStorage.getItem("i18nextLng") || "en_US";

  useEffect(() => {
    setIsFilterLoaded(true);

    API.dropdownAgentDataAPI({ operatorId: user.operatorId }).then(
      (response) => {
        setDropDownAreaData(response.data.all_areas);
      },
    );

    getHomeData();
  }, []);

  useEffect(() => {
    if (isFilterLoaded) {
      fetchCustomerData(); // ✅ NOW correct timing
    }
  }, [isFilterLoaded]);

  useEffect(() => {
    if (isDataLoaded && isFilterLoaded) {
      ChangeDataBasedOnFilter();
    }
  }, [
    isDataLoaded,
    isFilterLoaded,
    area,
    search,
    sortOptions,
    sortBy,
    sortType,
  ]);

  useEffect(() => {
    if (isDataLoaded) {
      const savedScroll = sessionStorage.getItem("customerScroll");

      if (savedScroll) {
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedScroll));

          sessionStorage.removeItem("customerScroll");
        }, 100);
      }
    }
  }, [isDataLoaded]);

  useEffect(() => {
    localStorage.setItem(
      "customerFilters",
      JSON.stringify({
        sortOptions,
        sortBy,
        sortType,
        area: area,
        search,
      }),
    );
  }, [area, search, sortOptions, sortBy, sortType]);

  useEffect(() => {
    const savedScroll = sessionStorage.getItem("customerScroll");

    if (savedScroll) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(savedScroll));
      }, 100);
    }
  }, []);

  const getHomeData = () => {
    const translateText = async () => {
      let translationArea = "All Areas";
      let translationSearch = "Search";
      let translationFilter = "Filter";
      try {
        if (localstorageValue === "hi_IN") {
          translationArea = await translate("All Areas", {
            from: "en",
            to: "hi",
          });
          translationSearch = await translate("Search", {
            from: "en",
            to: "hi",
          });
          translationFilter = await translate("Filter", {
            from: "en",
            to: "hi",
          });
        } else if (localstorageValue === "kn_IN") {
          translationArea = await translate("All Areas", {
            from: "en",
            to: "kn",
          });
          translationSearch = await translate("Search", {
            from: "en",
            to: "kn",
          });
          translationFilter = await translate("Filter", {
            from: "en",
            to: "kn",
          });
        } else if (localstorageValue === "ml_IN") {
          translationArea = await translate("All Areas", {
            from: "en",
            to: "ml",
          });
          translationSearch = await translate("Search", {
            from: "en",
            to: "ml",
          });
          translationFilter = await translate("Filter", {
            from: "en",
            to: "ml",
          });
        } else if (localstorageValue === "ta_IN") {
          translationArea = await translate("All Areas", {
            from: "en",
            to: "ta",
          });
          translationSearch = await translate("Search", {
            from: "en",
            to: "ta",
          });
          translationFilter = await translate("Filter", {
            from: "en",
            to: "ta",
          });
        } else if (localstorageValue === "te_IN") {
          translationArea = await translate("All Areas", {
            from: "en",
            to: "te",
          });
          translationSearch = await translate("Search", {
            from: "en",
            to: "te",
          });
          translationFilter = await translate("Filter", {
            from: "en",
            to: "te",
          });
        } else {
          translationArea = "All Areas";
          translationSearch = "Search";
          translationFilter = "Filter";
        }
      } catch (error) {
        console.error("Translation error:", error);
      }
      setTranslatedArea(translationArea);
      setTranslatedSearch(translationSearch);
      setTranslatedFilter(translationFilter);
    };
    translateText();
  };

  const Customers = () => {
    const [translatedCustomerNames, setTranslatedCustomerNames] = useState({});
    const [translatedStatusNames, setTranslatedStatusNames] = useState({});
    const [translatedDisplayNames, setTranslatedDisplayNames] = useState({});
    useEffect(() => {
      const translateCustomerNames = async () => {
        const translations = {};
        const translationsStatus = {};
        const translationsDisplay = {};

        for (const customer of filtercustomerData) {
          let translationCust = "";
          let translationStatus = "";
          let translationDisplay = "";

          try {
            if (localstorageValue === "hi_IN") {
              translationCust = await translate(customer.customerName, {
                from: "en",
                to: "hi",
              });
              translationStatus = await translate(customer.status, {
                from: "en",
                to: "hi",
              });
              translationDisplay = await translate(customer.displayField, {
                from: "en",
                to: "hi",
              });
            } else if (localstorageValue === "kn_IN") {
              translationCust = await translate(customer.customerName, {
                from: "en",
                to: "kn",
              });
              translationStatus = await translate(customer.status, {
                from: "en",
                to: "kn",
              });
              translationDisplay = await translate(customer.displayField, {
                from: "en",
                to: "kn",
              });
            } else if (localstorageValue === "ml_IN") {
              translationCust = await translate(customer.customerName, {
                from: "en",
                to: "ml",
              });
              translationStatus = await translate(customer.status, {
                from: "en",
                to: "ml",
              });
              translationDisplay = await translate(customer.displayField, {
                from: "en",
                to: "ml",
              });
            } else if (localstorageValue === "ta_IN") {
              translationCust = await translate(customer.customerName, {
                from: "en",
                to: "ta",
              });
              translationStatus = await translate(customer.status, {
                from: "en",
                to: "ta",
              });
              translationDisplay = await translate(customer.displayField, {
                from: "en",
                to: "ta",
              });
            } else if (localstorageValue === "te_IN") {
              translationCust = await translate(customer.customerName, {
                from: "en",
                to: "te",
              });
              translationStatus = await translate(customer.status, {
                from: "en",
                to: "te",
              });
              translationDisplay = await translate(customer.displayField, {
                from: "en",
                to: "te",
              });
            } else {
              translationCust = customer.customerName;
              translationStatus = customer.status;
              translationDisplay = customer.displayField;
            }
          } catch (error) {
            console.error("Translation error:", error);
          }
          translations[customer.managedCustomerId] = translationCust;
          translationsStatus[customer.managedCustomerId] = translationStatus;
          translationsDisplay[customer.managedCustomerId] = translationDisplay;
        }
        setTranslatedCustomerNames(translations);
        setTranslatedStatusNames(translationsStatus);
        setTranslatedDisplayNames(translationsDisplay);
      };
      translateCustomerNames();
    }, [filtercustomerData, localstorageValue]);

    const eachCustomer = filtercustomerData.map((customer) => {
      const translatedName =
        translatedCustomerNames[customer.managedCustomerId];
      const displayName = translatedName || "Loading...";

      return (
        <div
          key={customer.managedCustomerId}
          className="card-div"
          onClick={() => {
            sessionStorage.setItem("customerScroll", window.scrollY);
            navigate("/customer/collectPayment", {
              state: customer,
            });
          }}
        >
          <div className="card-group1-div">
            <div class="card-line1-div">
              <p className="card-name-p">{displayName}</p>
              <p
                className="card-price-p"
                style={{
                  color:
                    customer.totalPayableAmount > 0 ? "#DC1515" : "#a0c334",
                }}
              >
                ₹ {customer.totalPayableAmount}
              </p>
            </div>

            <div className="card-line2-div">
              <p className="card-date-p">{customer.endDate}</p>
              <p className="card-reg-p">{customer.managedCustomerId}</p>
            </div>

            <div className="card-line3-div">
              <div style={{ display: "flex" }}>
                <TfiMobile className="card-mobileIcon" />
                <p className="card-phone-p">{customer.phone}</p>
              </div>

              <p
                className="card-status-p"
                style={{
                  backgroundColor:
                    customer.status === "Active" || customer.status === "ACTIVE"
                      ? "#a0c334"
                      : customer.status === "Suspended"
                        ? "#DC1515"
                        : "#0090da",
                }}
              >
                {translatedStatusNames[customer.managedCustomerId]}
              </p>
            </div>
          </div>
          {customer.displayField ? (
            <div className="card-group2-div">
              <div className="card-underline-div"></div>
              <p className="card-address-p">
                {translatedDisplayNames[customer.managedCustomerId]}
              </p>
            </div>
          ) : null}
        </div>
      );
    });
    return <>{eachCustomer}</>;
  };

  const onClose = React.useCallback(() => {
    setIsVisible(false);
  }, []);

  const openDrawer = React.useCallback(() => setIsVisible(true), []);
  const ChangeDataBasedOnFilter = () => {
    let data = [...customerData];

    if (area !== "All") {
      data = data.filter((customer) => customer.AREA_ID.toString() === area);
    }

    if (search) {
      data = data.filter(
        (customer) =>
          customer.customerName?.toLowerCase().includes(search.toLowerCase()) ||
          customer.phone?.toLowerCase().includes(search.toLowerCase()) ||
          customer.managedCustomerId
            ?.toLowerCase()
            .includes(search.toLowerCase()),
      );
    }

    if (sortOptions === "Paid") {
      data = data.filter(
        (c) => c.status === "Active" && c.totalPayableAmount <= 0,
      );
    } else if (sortOptions === "Unpaid") {
      data = data.filter(
        (c) => c.status === "Active" && c.totalPayableAmount > 0,
      );
    }

    // SORTING
    if (sortBy === "CustomerId") {
      data.sort((a, b) =>
        a.managedCustomerId.localeCompare(b.managedCustomerId, "en", {
          numeric: true,
        }),
      );
    } else if (sortBy === "Pending") {
      data.sort((a, b) => a.totalPayableAmount - b.totalPayableAmount);
    }

    // Apply sort type properly
    if (sortType === "DESC") {
      data.reverse(); // ✅ only reverse for DESC
    }
    setfiltercustomerData(data);
  };

  const handleFilterSubmit = () => {
    setIsVisible(false);

    localStorage.setItem(
      "customerFilters",
      JSON.stringify({
        sortOptions,
        sortBy,
        sortType,
        area,
        search,
      }),
    );
  };
  if (!isFilterLoaded) return null;
  return (
    <>
      <div
        className="customer-container"
        style={{ backgroundColor: "#e8ebeb" }}
      >
        <div className="header-blue">
          <div
            className="area-div"
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <input
              type="text"
              placeholder={translatedSearch}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="area-input"
              style={{ width: "90%" }}
            />

            <select
              value={area}
              onChange={(e) => setArea(e.target.value)}
              className="area-select"
              style={{ width: "90%" }}
            >
              <option value="All">{translatedArea}</option>
              {dropDownAreaData.map((data) => (
                <option key={data.id} value={data.id.toString()}>
                  {data.area_name}
                </option>
              ))}
            </select>
          </div>

          <div className="filter-div">
            <p className="filter-p">{translatedFilter}</p>
            <div className="filter-button" onClick={() => openDrawer()}>
              <RiSortDesc className="filter-icon" />
            </div>
          </div>
        </div>

        <div className="customer-page-card-div">
          <FloatingButton />
          {isLoading && (
            <>
              <div
                className="card-div"
                style={{ border: "none", width: "90%" }}
              >
                <ContentLoader
                  speed={2}
                  width={400}
                  height={160}
                  viewBox="0 0 400 160"
                  backgroundColor="white"
                  foregroundColor="#333333"
                >
                  <rect x="80" y="20" rx="3" ry="3" width="220" height="10" />
                  <rect x="80" y="40" rx="3" ry="3" width="180" height="10" />
                  <rect x="80" y="60" rx="3" ry="3" width="130" height="10" />
                </ContentLoader>
              </div>
              <div
                className="card-div"
                style={{ border: "none", width: "90%" }}
              >
                <ContentLoader
                  speed={2}
                  width={400}
                  height={160}
                  viewBox="0 0 400 160"
                  backgroundColor="white"
                  foregroundColor="#333333"
                >
                  <rect x="80" y="20" rx="3" ry="3" width="220" height="10" />
                  <rect x="80" y="40" rx="3" ry="3" width="180" height="10" />
                  <rect x="80" y="60" rx="3" ry="3" width="130" height="10" />
                </ContentLoader>
              </div>
              <div
                className="card-div"
                style={{ border: "none", width: "90%" }}
              >
                <ContentLoader
                  speed={2}
                  width={400}
                  height={160}
                  viewBox="0 0 400 160"
                  backgroundColor="white"
                  foregroundColor="#333333"
                >
                  <rect x="80" y="20" rx="3" ry="3" width="220" height="10" />
                  <rect x="80" y="40" rx="3" ry="3" width="180" height="10" />
                  <rect x="80" y="60" rx="3" ry="3" width="130" height="10" />
                </ContentLoader>
              </div>
              <div
                className="card-div"
                style={{ border: "none", width: "90%" }}
              >
                <ContentLoader
                  speed={2}
                  width={400}
                  height={160}
                  viewBox="0 0 400 160"
                  backgroundColor="white"
                  foregroundColor="#333333"
                >
                  <rect x="80" y="20" rx="3" ry="3" width="220" height="10" />
                  <rect x="80" y="40" rx="3" ry="3" width="180" height="10" />
                  <rect x="80" y="60" rx="3" ry="3" width="130" height="10" />
                </ContentLoader>
              </div>
            </>
          )}
          <Customers />
        </div>
        <LoadingBar
          color="#f11946"
          height={4}
          shadow={true}
          progress={progress}
          onLoaderFinished={() => setProgress(0)}
        />

        <Drawer
          isVisible={isVisible}
          onClose={onClose}
          className={"drawer"}
          hideScrollbars={"true"}
        >
          <div style={{ padding: "10px" }}>
            <p className="DrawerTitle">{t("Customers_filters_sort_options")}</p>
            <div sty>
              <div className="SortOptionsContent">
                <p className="SortOptionsLabel">
                  {t("Customers_filters_sort_options_paid")}
                </p>
                <input
                  type={"radio"}
                  name={"sort-option"}
                  className="DrawerRadioButtons"
                  value="Paid"
                  checked={sortOptions === "Paid"}
                  onChange={(e) => setSortOptions(e.target.value)}
                />
              </div>
              <div className="SortOptionsContent">
                <p className="SortOptionsLabel">
                  {t("Customers_filters_sort_options_unpaid")}
                </p>
                <input
                  type={"radio"}
                  name={"sort-option"}
                  className="DrawerRadioButtons"
                  value="Unpaid"
                  checked={sortOptions === "Unpaid"}
                  onChange={(e) => setSortOptions(e.target.value)}
                />
              </div>
              <div className="SortOptionsContent">
                <p className="SortOptionsLabel">
                  {t("Customers_filters_sort_options_all")}
                </p>
                <input
                  type={"radio"}
                  name={"sort-option"}
                  value="All"
                  className="DrawerRadioButtons"
                  checked={sortOptions === "All"}
                  onChange={(e) => setSortOptions(e.target.value)}
                />
              </div>
            </div>
            <p className="DrawerTitle">{t("Customers_filters_sort_by")}</p>
            <div className="DrawerSortColumn">
              <div>
                <input
                  type={"radio"}
                  name={"sort-by"}
                  value={"Pending"}
                  className="DrawerRadioButtons"
                  checked={sortBy === "Pending"}
                  onChange={(e) => setSortBy(e.target.value)}
                />
                <label className="DrawerRadioLabel">
                  {t("Customers_filters_sort_by_pendingamt")}
                </label>
              </div>
              <div>
                <input
                  type={"radio"}
                  name={"sort-by"}
                  value={"CustomerId"}
                  id={"English"}
                  className="DrawerRadioButtons"
                  checked={sortBy === "CustomerId"}
                  onChange={(e) => setSortBy(e.target.value)}
                />
                <label className="DrawerRadioLabel">
                  {t("Customers_filters_sort_by_customerid")}
                </label>
              </div>
            </div>
            <p className="DrawerTitle" style={{ marginTop: "20px" }}>
              {t("Customers_filters_sort_type")}
            </p>
            <div className="DrawerSortColumn">
              <div>
                <input
                  type={"radio"}
                  name={"sort-type"}
                  value={"ASC"}
                  id={"English"}
                  className="DrawerRadioButtons"
                  checked={sortType === "ASC"}
                  onChange={(e) => setSortType(e.target.value)}
                />
                <label className="DrawerRadioLabel">
                  {t("Customers_filters_sort_type_asc")}
                </label>
              </div>
              <div>
                <input
                  type={"radio"}
                  name={"sort-type"}
                  value={"DESC"}
                  id={"English"}
                  className="DrawerRadioButtons"
                  checked={sortType === "DESC"}
                  onChange={(e) => setSortType(e.target.value)}
                />
                <label className="DrawerRadioLabel">
                  {t("Customers_filters_sort_type_desc")}
                </label>
              </div>
            </div>
            <button className="DrawerSubmitButton" onClick={handleFilterSubmit}>
              <span>{t("Customers_filters_submitbtn")}</span>
            </button>
          </div>
        </Drawer>
      </div>
      <Navbar value={1} />
    </>
  );
}
